export function createTemplateClient(transport) {
    return {
        /**
         * List this tenant's notification templates, newest version of each variant
         *
         * Requires scope: template:summary:read
         */
        listTenantTemplateSummaries(limit, after, options) {
            return transport.request({
                method: "GET",
                path: "/v1/notification-templates",
                query: { limit: limit, after: after },
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/templates
         *
         * Requires scope: template:write
         */
        createTemplateDraft(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/templates`,
                body,
                options,
            });
        },
        /**
         * GET /internal/v1/tenants/{tenantId}/templates/{templateKey}/versions/{version}
         *
         * Requires scope: template:read
         */
        getTemplateVersion(tenantId, templateKey, version, options) {
            return transport.request({
                method: "GET",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/templates/${encodeURIComponent(templateKey)}/versions/${encodeURIComponent(version)}`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/templates/{templateKey}/versions/{version}/publish
         *
         * Requires scope: template:publish
         */
        publishTemplateVersion(tenantId, templateKey, version, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/templates/${encodeURIComponent(templateKey)}/versions/${encodeURIComponent(version)}/publish`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/templates/{templateKey}/versions/{version}/retire
         *
         * Requires scope: template:retire
         */
        retireTemplateVersion(tenantId, templateKey, version, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/templates/${encodeURIComponent(templateKey)}/versions/${encodeURIComponent(version)}/retire`,
                options,
            });
        },
        /**
         * POST /internal/v1/tenants/{tenantId}/templates/render
         *
         * Requires scope: template:render
         */
        renderPublishedTemplate(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/templates/render`,
                body,
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=template.js.map